/* eslint-disable no-loop-func */
VjsAdmin.LicenseCloneForm = (function () {
    const me = {};
    me.numberOfClones = 0;
    me.$licenseCloneForm = $('#license-clone-form');
    me.$resultsBody = $('<div></div>');
    me.columns = {
        city: 0,
        'state-code': 0,
        zipcode: 0,
        'user-account-limit': 0,
        'license-active': 0,
        'license-searchable': 0,
        'license-type': 0,
        'grade-ids': 0,
        dates: 0,
    };

    me.platformId = me.$licenseCloneForm.attr('data-platform-id');
    me.districtJointGuid = me.$licenseCloneForm.attr('data-district-joint-guid');

    me.init = function () {
        $('#how-many-clones').on('click', (e) => {
            e.stopPropagation();
        });

        $('#how-many-clones').on('change keyup paste', function () {
            let value = $(this).val();
            if (value < 1) {
                value = 1;
                $(this).val(value);
                return false;
            }
            if (value > 1) {
                $('#clones_plural').show();
            } else {
                $('#clones_plural').hide();
            }
        });

        // only can remove the last clone row... otherwise I'd have to update all of the clone numbers :(
        $('#license-clone-table').on('click', 'tbody > tr > th .remove', function () {
            $(this).closest('tr').remove();
            me.numberOfClones--;
        });

        $('.add-clones-button').on('click', () => {
            const howMany = $('#how-many-clones').val();
            for (let i = 0; i < howMany; i++) {
                me.createclone();
            }
        });

        $('.enable-column-checkbox').each(function () {
            const field = $(this).attr('data-field');
            me.toggleColumn(field);
        });

        $('.enable-column-checkbox').on('change', function () {
            const field = $(this).attr('data-field');
            me.toggleColumn(field);
        });

        $('#license-clone-table').on('click', '.edit-dates', function () {
            const cloneNumber = $(this).closest('tr').attr('data-clone-number');
            const $dateRangeForm = $('<div>').html($('#date-range-form-template').html());
            const $continueButton = $('<button type="button" class="btn btn-blue" data-dismiss="modal">Continue</button>');

            $continueButton.on('click', (e) => {
                e.preventDefault();

                let errors = false;
                if ($('#date_range_from').val() === '') {
                    $('#date_range_from').removeClass('is-valid').addClass('is-invalid');
                    errors = true;
                } else {
                    $('#date_range_from').removeClass('is-invalid').addClass('is-valid');
                }
                if ($('#date_range_to').val() === '') {
                    $('#date_range_to').removeClass('is-valid').addClass('is-invalid');
                    errors = true;
                } else {
                    $('#date_range_to').removeClass('is-invalid').addClass('is-valid');
                }

                if (errors) {
                    return false;
                }

                if (
                    typeof $('#date_range_from').val() !== 'undefined'
                    && $('#date_range_from').val() !== null
                    && $('#date_range_from').val() !== ''
                ) {
                    $('#date_range_from').val(moment($('#date_range_from').val()).utc().format());
                    $(`#activation_date__${cloneNumber}`).val(moment($('#date_range_from').val()).utc().format('MM/DD/YYYY'));
                }
                if (
                    typeof $('#date_range_to').val() !== 'undefined'
                    && $('#date_range_to').val() !== null
                    && $('#date_range_to').val() !== ''
                ) {
                    $('#date_range_to').val(moment($('#date_range_to').val()).utc().format());
                    $(`#expiration_date__${cloneNumber}`).val(moment($('#date_range_to').val()).utc().format('MM/DD/YYYY'));
                }

                me.$date_range_modal.modal('hide');
                return true;
            });

            if (me.$date_range_modal) {
                me.$date_range_modal.data('modal', null);
                me.$date_range_modal.remove();
            }

            me.$date_range_modal = VjsAdmin.Modal.create({
                id: `clone-${cloneNumber}-dates-modal`,
                title: 'Choose Date Range for this clone',
                body: $dateRangeForm,
                footer: $continueButton,
                onShown() {
                    VjsAdmin.initDateRangePickers($(`#clone-${cloneNumber}-dates-modal`));
                    // set initial date values...
                    $(`#clone-${cloneNumber}-dates-modal .datetimepicker-from`)
                        .data('DateTimePicker')
                        .date(moment($(`#activation_date__${cloneNumber}`).val()).utc());
                    $(`#clone-${cloneNumber}-dates-modal .datetimepicker-to`)
                        .data('DateTimePicker')
                        .date(moment($(`#expiration_date__${cloneNumber}`).val()).utc());
                },
            });

            // hide and remove modal
            me.$date_range_modal.on('hide.bs.modal hidden.bs.modal', () => {
                // destroying existing modal because hidden
                me.$date_range_modal.data('modal', null);
                me.$date_range_modal.remove();
            });

            me.$date_range_modal.modal({ backdrop: 'static', keyboard: false });
        });

        $('#license-clone-form').on('submit', function (e) {
            e.preventDefault();
            VjsAdmin.startProcessing();
            me.$resultsBody = $('<div><ul class="results-list"></ul></div>');

            const postUrl = $(this).attr('action');
            const formData = $(this).serializeControls();

            // array to store jqXHR promises to wait on
            let numberProcessed = 0;
            let numberFailed = 0;
            let numberSkipped = 0;

            // for each license to create...
            for (let i = 1; i <= me.numberOfClones; i++) {
                // skip already cloned rows...
                if ($(`#clone__${i}`).hasClass('success')) {
                    numberSkipped++;
                    continue;
                }

                // form the data array that will be passed
                const licenseData = {};
                licenseData.clone_number = i;
                licenseData.license_name = formData.license_name[i];
                licenseData.street_address = formData.street_address[i];
                licenseData.street_address_2 = formData.street_address_2[i];
                if (+me.columns.city === 1) {
                    licenseData.city = formData.city[i];
                }
                if (+me.columns['state-code'] === 1) {
                    licenseData.state_code = formData.state_code[i];
                }
                if (+me.columns.zipcode === 1) {
                    licenseData.zipcode = formData.zipcode[i];
                }
                if (+me.columns['user-account-limit'] === 1) {
                    licenseData.user_account_limit = formData.user_account_limit[i];
                }
                if (+me.columns['license-active'] === 1) {
                    licenseData.active = formData.active[i];
                }
                if (+me.columns['license-searchable'] === 1) {
                    licenseData.searchable = formData.searchable[i];
                }
                if (+me.columns['license-type'] === 1) {
                    licenseData.license_type_id = $(`#license_type_id__${i}`).val(); // form_data.license_type_id[i];
                }
                if (+me.columns['grade-ids'] === 1) {
                    licenseData.grade_ids = $(`#grade_ids__${i}`).val();
                }
                if (+me.columns.dates === 1) {
                    licenseData.activation_date = formData.activation_date[i];
                    licenseData.expiration_date = formData.expiration_date[i];
                }

                let $resultsContinueButton = '';
                $.ajax({
                    type: 'POST',
                    dataType: 'json',
                    url: postUrl,
                    data: licenseData,
                })
                    .done((response) => {
                        $(`tr#clone__${response.clone_number}`).removeClass('error');
                        $(`tr#clone__${response.clone_number}`).addClass('success');
                        const $resultLi = $(
                            `<li class="success">#${response.clone_number}: Created License <a href="${Slim.Router.pathFor(
                                'platforms.districts.licenses.view',
                                {
                                    platform_id: me.platformId,
                                    district_joint_guid: me.districtJointGuid,
                                    license_id: response.clone.data.license_id,
                                },
                            )}" target="_blank">${response.clone.data.license_name}, ${response.clone.data.city}, ${
                                response.clone.data.state_code
                            }</a></li>`,
                        );
                        me.$resultsBody.find('.results-list').append($resultLi);
                    })
                    .fail((jqXHR) => {
                        numberFailed++;
                        const response = jqXHR.responseJSON;
                        $(`tr#clone__${response.clone_number}`).addClass('error');
                        const $errors = $('<ul></ul>');
                        $.each(response.field_errors, (field, fieldError) => {
                            $errors.append(`<li>${fieldError}</li>`);
                        });
                        const $resultLi = $(
                            `<li class="error">#${response.clone_number}: Error creating Clone... fix the following errors and submit again.</li>`,
                        );
                        $resultLi.append($errors);
                        me.$resultsBody.find('.results-list').append($resultLi);
                    })
                    .always(() => {
                        numberProcessed++;
                        if (numberSkipped + numberProcessed >= me.numberOfClones) {
                            VjsAdmin.stopProcessing();
                            me.$licenseCloneForm.find('button, input[type=submit]').prop('disabled', false);
                            if (+numberFailed === 0) {
                                $resultsContinueButton = $(
                                    `<a href="${Slim.Router.pathFor('platforms.districts.licenses.list', {
                                        platform_id: me.platformId,
                                        district_joint_guid: me.districtJointGuid,
                                    })}?order_by=date_created" class="btn btn-blue">Go to Licenses List</button>`,
                                );
                            } else {
                                $resultsContinueButton = $(
                                    '<button type="button" class="btn btn-blue" data-dismiss="modal">Continue / Fix Errors</button>',
                                );
                            }

                            // create the modal
                            me.$results_modal = VjsAdmin.Modal.create({
                                id: 'clone-results-modal',
                                title: 'Cloning Results',
                                body: me.$resultsBody,
                                footer: $resultsContinueButton,
                            });

                            // hide and remove modal
                            me.$results_modal.on('hide.bs.modal hidden.bs.modal', () => {
                                // destroying existing modal because hidden
                                me.$results_modal.data('modal', null);
                                me.$results_modal.remove();
                            });

                            me.$results_modal.modal({
                                backdrop: 'static',
                                keyboard: false,
                            });
                        }
                    });
                // );
            }

            if (numberSkipped + numberProcessed >= me.numberOfClones) {
                VjsAdmin.stopProcessing();
                me.$licenseCloneForm.find('button, input[type=submit]').prop('disabled', false);
            }
        });

        me.createclone();
    };

    // create a copy of the hidden field set...
    me.createclone = function () {
        const $source = $('#clone__0').clone();

        // increment the clone number
        me.numberOfClones++;

        // replace __0 with the new clone number in all places...
        $source.attr('id', $source.attr('id').replace('__0', `__${me.numberOfClones}`));
        $source.attr('data-clone-number', me.numberOfClones);
        $source.find('.clone-number').text(me.numberOfClones);
        $source.find('input,select').each(function () {
            $(this).attr('name', $(this).attr('name').replace('[0]', `[${me.numberOfClones}]`));
            $(this).attr('id', $(this).attr('id').replace('__0', `__${me.numberOfClones}`));
        });
        $source.fadeIn();

        // add new clone to the table body...
        $('#license-clone-table tbody').append($source);

        // set up the grade ids multiselect interfacee, if needed.
        if ($('#enable-grade-ids').is(':checked')) {
            $(`.field-grade-ids select#grade_ids__${me.numberOfClones}`).multiselect();
        }

        // set the necessary fields to be required...
        $(`#license_name__${me.numberOfClones}`).prop('required', true);
        $(`#street_address__${me.numberOfClones}`).prop('required', true);
        $(`#state_code__${me.numberOfClones}`).prop('required', true);
        $(`#city__${me.numberOfClones}`).prop('required', true);
        $(`#zipcode__${me.numberOfClones}`).prop('required', true);
        $(`#user_account_limit__${me.numberOfClones}`).prop('required', true);
    };

    me.toggleColumn = function (field) {
        const checked = $(`input.enable-column-checkbox[data-field=${field}]`).is(':checked');
        me.columns[field] = checked ? 1 : 0;
        $(`.field-${field}`).toggleClass('disabled', !checked);
        $(`.field-${field} input, .field-${field} select`).prop('disabled', !checked);
        if (field === 'grade-ids') {
            if (checked) {
                $('.field-grade-ids select:not(#grade_ids__0)').multiselect();
            } else {
                $('.field-grade-ids select:not(#grade_ids__0)').multiselect('destroy');
            }
        }
    };

    return {
        init: me.init,
    };
}());
